export default __webpack_public_path__ + "static/media/coming-soon-dashboard.598dcfa2.png";